import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;

export const outlineMoveToLineDialogStyleId = 'service-plan-outline-move-to-line-dialog-theme';

export const outlineMoveToLineDialogBridgeStyles = {
  'service-plan-outline-move-to-line-dialog': {
    '--local-move-to-line-bg': tokens.color.background.primary,
    '--local-move-to-line-title': tokens.color.text.primary,
    '--local-move-to-line-body': tokens.color.text.secondary,
    '--local-move-to-line-option-text': tokens.color.text.primary,
    '--local-move-to-line-option-hover': tokens.color.background.primaryHover,
    '--local-move-to-line-gap': tokens.spacing.lg,
    '--local-move-to-line-pad': tokens.spacing.xl,
    '--local-move-to-line-option-pad': tokens.spacing.md,
    '--local-move-to-line-radius': tokens.radius.md,
    '--local-move-to-line-title-size': tokens.font.size.textLg,
    '--local-move-to-line-body-size': tokens.font.size.textSm,
    '--local-move-to-line-title-weight': tokens.font.weight.semibold,
    '--local-move-to-line-line-title': tokens.lineHeight.textLg,
    '--local-move-to-line-line-body': tokens.lineHeight.textSm,
    '--local-move-to-line-font': tokens.font.family.body,
    '--local-move-to-line-focus': tokens.focusRing.default,
  },
};
